import { vars } from "@imwebme/clay-token";
import type { Ref } from "react";
import { forwardRef } from "react";
import { Flex } from "../utilities";
import { contentAnimation, modalSizeMap } from "./Modal.css";
import type { ModalContainerProps } from "./Modal.types";

export const ModalContainer = forwardRef(
  ({ width, fullHeight, children }: ModalContainerProps, ref: Ref<HTMLDivElement>) => {
    return (
      <Flex.Column
        ref={ref}
        backgroundColor={vars.semantic.color.surface}
        borderRadius={vars.rounded.xlarge}
        overflow="hidden"
        width={modalSizeMap[width]}
        height={fullHeight ? "100%" : "auto"}
        boxShadow={vars.dropShadow.modal}
        animation={`${contentAnimation} 0.2s ease-out`}
        native={{ role: "dialog", onClick: (e) => e.stopPropagation() }}
      >
        {children}
      </Flex.Column>
    );
  },
);
